import { render, staticRenderFns } from "./InvoiceAmount.vue?vue&type=template&id=5baaf9fe&"
import script from "./InvoiceAmount.vue?vue&type=script&lang=js&"
export * from "./InvoiceAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports